import { SuggestedProductService } from '@/services/admin/SuggestedProductService'
import { build_query } from '@/utilities/helpers.js'

export const namespaced = true

export const allowedFilters = ['name', 'created_between']

export const allowedSorts = '-created_at'

export const state = {
  suggestedProducts: [],
  meta: null
}

export const mutations = {
  SET_SUGGESTED_PRODUCTS(state, suggestedProducts) {
    state.suggestedProducts = suggestedProducts.data
    state.meta = suggestedProducts.meta
  }
}

export const actions = {
  getSuggestedProducts({ commit }, query) {
    let newQuery = build_query(query, allowedFilters, null, allowedSorts)
    return new Promise(resolve => {
      SuggestedProductService.getSuggestedProducts(newQuery).then(response => {
        commit('SET_SUGGESTED_PRODUCTS', response)
        resolve(response.data)
      })
    })
  },
  getSuggestedProductsExport({ commit }, query) {
    let newQuery = build_query(query, allowedFilters, null, allowedSorts)
    return new Promise(resolve => {
      SuggestedProductService.getSuggestedProductsExport(newQuery).then(response => {
        commit('SET_SUGGESTED_PRODUCTS', response)
        resolve(response.data)
      })
    })
  }
}
